import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Color } from 'core';

interface IBrightInput {
  placeholder?: string;
  autoFocus?: boolean;
  required?: boolean;
  bright?: boolean;
  style?: any;
  type?: 'password' | 'email' | 'text';
  name?: string;
  value?: string;
  onChange?(event): void;
  onKeyPress?(event): void;
  'aria-labelledby'?: string;
  className?: string;
  disabled?: boolean;
}

const BaseInput = styled.input`
  color: ${Color.slateGray};
  line-height: 22px;
  font-size: 18px;
  padding: 15px;
  margin: 20px auto 20px auto;
  width: 100%;
  background-color: ${Color.primaryGray};
  border-radius: 5px;
  border: 1px solid ${Color.lightGray};
  box-sizing: border-box;
`;

export const BrightInput = React.memo<IBrightInput>((props) => {
  const { t } = useTranslation();

  return (
    <BaseInput
      className={props.className}
      placeholder={props.placeholder || t('Enter some text here')}
      onChange={props.onChange}
      onKeyPress={props.onKeyPress}
      autoFocus={props.autoFocus}
      required={props.required}
      style={props.bright ? {} : styles.dim}
      name={props.name}
      type={props.type || 'text'}
      value={props.value}
      aria-labelledby={props['aria-labelledby']}
      disabled={props.disabled}
    />
  );
});

const styles = {
  dim: {
    outline: 'none',
  },
};
